<template>
    <div>
        <v-flex align-start>
            <v-chip v-for="email in emails" close @input="removeEmail(email)">
                <v-avatar class="primary"> {{email.substring(0, 1).toUpperCase()}}</v-avatar>
               {{email}}
            </v-chip>
        </v-flex>
        <v-text-field
                v-model="currentEmail"
                @change="addEmail"
                :rules="[rules.empty]"
                :label="labelTxt"
                :hint="labelHint"
                autocomplete="new-password"
        >
        </v-text-field>
    </div>
</template>

<script>
    import {VChip,VAvatar,VTextField,VFlex} from 'vuetify/lib';

    export default {
        name: "MultipleEmailSelect",
        components:{VChip,VAvatar,VTextField,VFlex},
        props: ['value','user'],
        computed: {
            labelTxt: function() {
                if (this.emails.length == 0)
                    return this.$t('Send license to (email)');
                else
                    return this.$t('Add another address');
            },
            labelHint: function() {
                if (this.user) {
                    return this.$t('Get free credits when this user registers!');
                } else {
                    return "";
                }
            }
        },
        data () {
            return {

                rules:{
                    empty: () => {
                        return (this.emails.length!=0)
                    },
                    email: value => {
                        if(value=='') return true;
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    }
                },

                currentEmail:'',

                emails: this.value,
            }
        },
        methods:{
            update:function(){
              this.$emit('input',this.emails)
            },
            addEmail:function (value) {
                let emails = value.split(" ").join(",").split(",");
                for (let email of emails) {
                    if (this.rules.email(email) === true && email != '') {
                        this.emails.push(email);
                    }
                    this.currentEmail = '';
                }
                this.update();
            },
            removeEmail (item) {
                this.emails.splice(this.emails.indexOf(item), 1);
                this.emails = [...this.emails];
                this.update();
            }
        }
    }

</script>

<style scoped>

</style>